const Cookies = () => import('@/components/Dashboard/Views/Cookies/Views/Cookies')
const DashboardLayout = () => import('@/components/Dashboard/Layout/DashboardLayout.vue')

export default {
  path: 'cookies',
  component: DashboardLayout,
  props: true,
  children: [
    {
      path: '',
      name: 'Cookies',
      component: Cookies,
      props: true,
    },
  ],
}
